"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlsForm = void 0;
const Netwtorking_1 = require("../../../public/js/utils/Netwtorking");
const LinkBuilder_1 = require("../../../public/js/utils/LinkBuilder");
const DOM_1 = require("../../../public/js/utils/DOM");
const RequestTypes_1 = require("../../../public/js/definitions/utils/networking/RequestTypes");
var ControlsForm;
(function (ControlsForm) {
    class Controller {
        static getFormData(formElement, overrideParams = []) {
            const collectedFormValues = [];
            const inputs = formElement.getElementsByTagName("input");
            for (let index = 0; index < inputs.length; ++index) {
                const input = inputs[index];
                if (input.classList.contains('select-dropdown')
                    || input.classList.contains('dropdown-input')
                    || input.classList.contains('items-placeholder')
                    || input.classList.contains('iti__search-input')
                    || input.classList.contains('DateTimePicker-generated')
                    || input.classList.contains('tomselect-checkbox')) {
                    continue;
                }
                if (input.classList.contains('skip')) {
                    continue;
                }
                const inputType = input.getAttribute("type");
                let inputName = input.getAttribute("name");
                const isInteger = input.dataset.integer;
                if (!inputName) {
                    console.warn('Missing name on input:', input);
                    continue;
                }
                inputName = inputName.replace("[]", "");
                const length = inputs[index].value.length;
                if (input.classList.contains('PhoneInput-input-input')) {
                    let data = DOM_1.DOM.Parser.getDataByNameFromElementOrNull('data', input);
                    collectedFormValues[inputName] = data && data.trim().length > 0 ? JSON.parse(data) : null;
                }
                else if (inputType === "radio") {
                    if (input.checked) {
                        collectedFormValues[inputName] = isInteger ? parseInt(input.value) : input.value;
                    }
                    else if (!collectedFormValues[inputName]) {
                        collectedFormValues[inputName] = null;
                    }
                }
                else if (inputType === "checkbox") {
                    collectedFormValues[inputName] = input.checked;
                }
                else if ((inputType === "text" || inputType === "email" || inputType === 'password') && length > 0) {
                    collectedFormValues[inputName] = isInteger ? parseInt(input.value.trim()) : input.value.trim();
                }
                else if ((inputType === 'hidden') && length > 0) {
                    collectedFormValues[inputName] = isInteger ? parseInt(input.value.trim()) : input.value.trim();
                }
                else if (inputType === "number" && length > 0) {
                    collectedFormValues[inputName] = parseInt(input.value.trim(), 10);
                }
                else {
                    collectedFormValues[inputName] = null;
                }
            }
            const areas = formElement.getElementsByTagName("textarea");
            for (let index = 0; index < areas.length; ++index) {
                const inputName = areas[index].getAttribute("name");
                if (!inputName) {
                    console.warn("Missing name on textarea");
                    continue;
                }
                if (areas[index].classList.contains('skip')) {
                    continue;
                }
                const length = areas[index].value.length;
                collectedFormValues[inputName] = length > 0 ? areas[index].value.trim() : null;
            }
            const selects = formElement.getElementsByTagName("select");
            for (let index = 0; index < selects.length; ++index) {
                let selectName = selects[index].getAttribute("name");
                const isInteger = selects[index].dataset.integer;
                if (!selectName) {
                    console.warn("Missing name on select");
                    continue;
                }
                if (selects[index].classList.contains('skip')) {
                    continue;
                }
                selectName = selectName.replace('[]', '');
                if (selects[index].classList.contains('multiChoose') || selects[index].multiple) {
                    let values = [];
                    for (let i = 0, iLen = selects[index].options.length; i < iLen; i++) {
                        const option = selects[index].options[i];
                        if (option.selected) {
                            values.push(isInteger ? parseInt(option.value.trim()) : option.value.trim());
                        }
                        collectedFormValues[selectName] = values;
                    }
                }
                else {
                    const length = selects[index].value.trim().length;
                    let value = length > 0 ? selects[index].value.trim() : null;
                    if (length > 0 && isInteger && value && value !== "0") {
                        collectedFormValues[selectName] = parseInt(value);
                    }
                    else if (value && length > 0 && value !== "0") {
                        collectedFormValues[selectName] = value;
                    }
                    else {
                        collectedFormValues[selectName] = null;
                    }
                }
            }
            return { ...collectedFormValues, ...overrideParams };
        }
        static disableActionsInForm(formElement) {
            formElement.style.opacity = '80%';
            formElement.style.pointerEvents = 'none';
            const inputs = formElement.getElementsByTagName("input");
            for (let index = 0; index < inputs.length; ++index) {
                if (inputs[index].type === "submit") {
                    inputs[index].disabled = true;
                }
                else {
                    inputs[index].style.setProperty("border-color", "#9e9e9e", "important");
                }
            }
            const buttons = formElement.getElementsByTagName("button");
            for (let index = 0; index < buttons.length; ++index) {
                buttons[index].disabled = true;
            }
            const areas = formElement.getElementsByTagName("textarea");
            for (let index = 0; index < areas.length; ++index) {
                areas[index].style.setProperty("border-color", "rgb(190,190,190)", "important");
            }
        }
        static enableActionsInForm(formElement) {
            formElement.style.opacity = '100%';
            formElement.style.pointerEvents = 'auto';
            const inputs = formElement.getElementsByTagName("input");
            for (let index = 0; index < inputs.length; ++index) {
                if (inputs[index].type === "submit") {
                    inputs[index].disabled = false;
                }
                else {
                    inputs[index].style.removeProperty("border-color");
                }
            }
            const buttons = formElement.getElementsByTagName("button");
            for (let index = 0; index < buttons.length; ++index) {
                buttons[index].disabled = false;
            }
            const areas = formElement.getElementsByTagName("textarea");
            for (let index = 0; index < areas.length; ++index) {
                areas[index].style.removeProperty("border-color");
            }
        }
        static async sendFormDataRequest(formElement, requestParameters) {
            requestParameters.event.stopPropagation();
            requestParameters.event.preventDefault();
            const formId = formElement.getAttribute('id');
            let link;
            if (requestParameters.linkParameters) {
                link = LinkBuilder_1.LinkBuilder.LinkBuilderController.composeLink(requestParameters.linkParameters);
            }
            else {
                link = formElement.getAttribute('action') + '';
            }
            await Netwtorking_1.Networking.NetworkingController.createRequest({
                type: RequestTypes_1.RequestTypes.POST,
                url: link,
                formData: requestParameters.formDataObject,
                disableButtons: requestParameters.forceDisabledButtons ? requestParameters.forceDisabledButtons : null,
                muteSuccess: requestParameters.muteSuccess,
                data: requestParameters.formData,
                successCallback: requestParameters.successCallback,
                startCallback: () => {
                    this.disableActionsInForm(formElement);
                    if (requestParameters.startCallback) {
                        requestParameters.startCallback();
                    }
                },
                completedCallback: (payload) => {
                    if ((!payload || !payload.redirect) && document.getElementById(formId)) {
                        this.enableActionsInForm(formElement);
                    }
                    if (requestParameters.completedCallback) {
                        requestParameters.completedCallback();
                    }
                },
                errorCallback: requestParameters.errorCallback,
                snippetCallback: requestParameters.snippetCallback,
                silent: requestParameters.silent,
                dontProcessPayload: requestParameters.dontProcessPayload,
                rawJsonResponse: requestParameters.rawJsonResponse
            });
        }
    }
    ControlsForm.Controller = Controller;
})(ControlsForm || (exports.ControlsForm = ControlsForm = {}));
